<p class="textS+" style="height: 80%; margin: 0">
  {{this.localiser.get("fade.info.sentence1")}}<br>
  {{this.localiser.get("fade.info.sentence2")}}
</p>
<div style="text-align: center; height: 20%">
  <button class="customButtonColor textS" mat-button (click)="onCancelClick()">{{this.localiser.get("fade.buttonClose")}}</button>
</div>
